// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `video {
    right: 0;
    bottom: 0;
    min-width: 100%; 
    min-height: 100%;
}

.video_navigation_bar__GGeEk {
    background-color: transparent;
    height: 140px;
    width: 100%;
    z-index: 9999;
    position: absolute;
    top: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.video_navigation_buttons__1Jz14 {
    margin-right: 3%;
}

.video_content_body__w\\+pt\\+ {
    z-index: 999;
    position: absolute;
    bottom: 5%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    width: 94%;
}

.video_welcome_text__NjApk {
    position: absolute;
    left: 5%;
    top: 22%;
    font-size: 47px;
}

.video_aboutus_text__kYPo8 {
    position: fixed;
    left: 5%;
    top: 17%;
    font-size: 40px;
}

.video_first_h1__Y-l2M {
    margin-bottom: 0;
    margin-bottom: -3vh;
}

.video_second_h1__sdkxe  {
    margin-top: 0;
    margin-bottom: 0;
}

h6 {
    margin-top: 0;
    margin-bottom:0;
}

.video_cards__gM7dF {
    background-color: #c9c9c94a;
    width: 32%;
    height: 34vh;
    border-radius: 60px;
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
}

.video_policycard__mvNDd {
    background-color: #c9c9c94a;
    width: 70%;
    height: 70vh;
    border-top-left-radius: 60px;
    border-bottom-left-radius: 60px;
    padding: 20px 30px;
    margin: auto 0;
}

.video_logo__nW2B1 {
    width: 250px;
    height: 125px;
    position: absolute;
    left: 4%;
    top: 0;
}

.video_hamburgerLogo__JCNsY {
    width: 150px;
    height: 75px;
    position: fixed;
    right: 4%;
    top: 16px;
    z-index: 1;
}

.video_right_buttons_container__Xcfto {
    position: absolute;
    right: 4%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.video_demo_button__HhJhr {
    width: 150px;
    height: 40px;
    background-color: #fff;
    border-radius: 30px;
    border: none;
    pointer-events: none;
    margin-top: 80px;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
}

.video_order_button__uJFuX:hover {
    background-color: blue;
    color:#fff;
}

.video_logo_disable__fBTZc {
    pointer-events: none;
}

.video_horizontal_team__MMqRE {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0px 10px 0px 10px;
    /* padding: 18% 10px 10px 10px; */
}

.video_team_member__V6TQy {
    font-weight: bold;
    padding-left: 10px;
}

.video_team_function__UBWs6 {
    margin-left: 10px;
}

.video_subText__l0qco  {
    font-family: 'LuxoraGoretskThin', sans-serif !important;
    position: absolute;
}

.video_contact_body__3mE2e {
    z-index: 999;
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 94%;
    height: 100%;
}

.video_contact_container__eCLu4 {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 90%;
}

iframe.video_contact_iframe__LHcJN iframe {
    font-family: 'LuxoraGoretskThin', sans-serif !important;
}

@font-face {
    font-family: 'Poppins';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

.video_animation_container__jz\\+YZ {
    overflow: hidden;
    position: absolute;
    transition: all 0.5s ease-in-out;
    font-family: Poppins;
    top: 29.25%;
    left: 18.7%;
    font-size: 35px;
}  

.video_responsiveCard__AvXHC {
    position: absolute;
    z-index: 9999999;
    width: 470px;
    height: 320px;
    animation-delay: 1.5s;
    animation-duration: 1s;
    bottom: 50%;
    background-color: #c9c9c94a;
    border-radius: 60px;
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
}

@media only screen and (max-width: 277px) {
    .video_first_h1__Y-l2M span {
        font-size: 40px !important;
    }

    .video_subText__l0qco {
        height: 50px !important;
        width: 260px !important;
        font-size: 19px !important;
    }
    
    .video_second_h1__sdkxe span {
        margin-top: 7px !important;
        font-size: 30px !important;
    }
    .video_responsiveCard__AvXHC {
        width: 232px !important;
        height: 240px !important;
    } 

    .video_demo_button__HhJhr {
        margin-top: 90px !important;
    } 

    .video_horizontal_team__MMqRE {
        margin: 12% 15% 0 10% !important;
        font-size: 13px;
    }
    .video_responsive_video__T2-9Y {
        scale: 4 !important;
    }
}
  

@media only screen and (min-width: 278px) and (max-width: 385px) {
    .video_first_h1__Y-l2M span {
        font-size: 25px !important;
    }

    .video_subText__l0qco {
        height: 100px;
        width: 310px;
        font-size: 20px;
    }
    
    .video_second_h1__sdkxe span {
        margin-top: 7px !important;
        font-size: 25px !important;
    }
    .video_responsiveCard__AvXHC {
        width: 255px !important;
        height: 260px;
    } 

    .video_demo_button__HhJhr {
        margin-top: 110px !important;
    } 

    .video_horizontal_team__MMqRE {
        margin: 12% 15% 0 10% !important;
        font-size: 15px;
    }
}
@media only screen and (min-width: 386px) and (max-width: 404px) {

    .video_horizontal_team__MMqRE {
        margin: 10% 10% 0 6%;
        font-size: 15px;
    }

    .video_subText__l0qco {
        height: 100px;
        width: 323px !important;
        font-size: 18px;
    }

    .video_responsiveCard__AvXHC {
        width: 340px;
        height: 230px;
    } 

    .video_first_h1__Y-l2M span {
        font-size: 38px !important;
    }
    
    .video_second_h1__sdkxe span {
        margin-top: 30px !important;
        font-size: 30px !important;
    }

    .video_demo_button__HhJhr {
        margin-top: 120px;
    } 
}

/* Mobil ekranlar için stil */
@media only screen and (min-width: 405px) and (max-width: 600px) {

    .video_horizontal_team__MMqRE {
        margin: 10% 10% 0 8%;
        font-size: 14px;
    }

    .video_subText__l0qco {
        height: 100px;
        width: 376px !important;
        font-size: 20px;
    }

    .video_responsiveCard__AvXHC {
        width: 340px;
        height: 230px;
    } 

    .video_first_h1__Y-l2M span {
        font-size: 38px !important;
    }
    
    .video_second_h1__sdkxe span {
        margin-top: 30px !important;
        font-size: 30px !important;
    }

    .video_demo_button__HhJhr {
        margin-top: 120px;
    } 
}

@media only screen and (min-width: 601px) and (max-width: 767px) {

    .video_horizontal_team__MMqRE {
        margin: 5% 10% 10% 10%;
    }

    .video_responsiveCard__AvXHC {
        width: 90%;
        height: 250px;
    } 

    .video_first_h1__Y-l2M span {
        font-size: 70px !important;
    }
    
    .video_second_h1__sdkxe span {
        margin-top: 30px !important;
        font-size: 50px !important;
    }

    .video_demo_button__HhJhr {
        margin-top: 100px;
    } 
}
  /* Tablet ekranlar için stil */
@media only screen and (min-width: 768px) and (max-width: 1023px) {
    .video_horizontal_team__MMqRE {
        margin: 16% 10px 10px 10px;
    }

    .video_first_h1__Y-l2M span {
        font-size: 80px !important;
        margin-bottom: 10px !important;
    }
    
    .video_second_h1__sdkxe span {
        font-size: 60px !important;
    }
}

@media only screen and (min-width: 1024px) and (max-width: 1038px){
    .video_second_h1__sdkxe span {
        font-size: 87px !important;
    }
    .video_horizontal_team__MMqRE {
        margin: 16% 10% 10% 10%;
    }
}

  /* Dizüstü bilgisayarlar için stil */
/* @media only screen and (min-width: 1024px) and (max-width: 1439px) { */
    /* Dizüstü için özel stiller burada */
/* } */
  /* Masaüstü ekranlar için stil */
/* @media only screen and (min-width: 1440px) { */
    /* Masaüstü için özel stiller burada */
/* } */

@media screen and (max-width:1608px) {
    .video_animation_container__jz\\+YZ {
        left: 19.7%;
    }
}

@media screen and (max-width:1578px) {
    .video_animation_container__jz\\+YZ {
        left: 36.7%;
    }
}

@media screen and (max-width:1554px) {
    .video_animation_container__jz\\+YZ {
        left: 19.7%;
    }
}

@media screen and (max-width:1491px) {
    .video_animation_container__jz\\+YZ {
        font-size: 25px;
        left: 20.7%;
        top: 34.25%;
    }   
}

@media screen and (max-width:1302px) {
    .video_animation_container__jz\\+YZ {
        left: 22.7%;
        top: 34.25%;
    }   
}

@media screen and (max-width:1215px) {
    .video_animation_container__jz\\+YZ {
        font-size: 20px;
        left: 23.7%;
        top: 38.25%;
    }
}

@media screen and (max-width:1116px) {
    .video_animation_container__jz\\+YZ {
        font-size: 12px;
        left: 25.7%;
        top: 43.25%;
    }
}

@media screen and (max-width:1060px) {
    .video_animation_container__jz\\+YZ {
        font-size: 12px;
        left: 25.7%;
        top: 43.25%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/HomePage/video.module.css"],"names":[],"mappings":"AAAA;IACI,QAAQ;IACR,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,kCAA0B;YAA1B,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,UAAU;IACV,YAAY;IACZ,4BAA4B;IAC5B,+BAA+B;IAC/B,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,SAAS;IACT,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uDAAuD;IACvD,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,sBAAsB;IACtB,+DAAsE;AAC1E;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,oBAAoB;IACpB,WAAW;IACX,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,sBAAsB;IACtB,WAAW;IACX,2BAA2B;IAC3B,mBAAmB;IACnB,kCAA0B;YAA1B,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,uBAAuB;QACvB,uBAAuB;QACvB,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;QAC1B,0BAA0B;IAC9B;IACA;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,gCAAgC;QAChC,eAAe;IACnB;IACA;QACI,mBAAmB;IACvB;AACJ;;;AAGA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,0BAA0B;QAC1B,0BAA0B;IAC9B;IACA;QACI,uBAAuB;QACvB,aAAa;IACjB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,gCAAgC;QAChC,eAAe;IACnB;AACJ;AACA;;IAEI;QACI,oBAAoB;QACpB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;IAC9B;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA,6BAA6B;AAC7B;;IAEI;QACI,oBAAoB;QACpB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;IAC9B;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;;IAEI;QACI,sBAAsB;IAC1B;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;IAC9B;;IAEA;QACI,iBAAiB;IACrB;AACJ;EACE,8BAA8B;AAChC;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;QAC1B,8BAA8B;IAClC;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,uBAAuB;IAC3B;AACJ;;EAEE,oCAAoC;AACtC,yEAAyE;IACrE,qCAAqC;AACzC,MAAM;EACJ,gCAAgC;AAClC,iDAAiD;IAC7C,sCAAsC;AAC1C,MAAM;;AAEN;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;QACX,WAAW;IACf;AACJ;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,WAAW;IACf;AACJ;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,WAAW;IACf;AACJ;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,WAAW;IACf;AACJ","sourcesContent":["video {\n    right: 0;\n    bottom: 0;\n    min-width: 100%; \n    min-height: 100%;\n}\n\n.navigation_bar {\n    background-color: transparent;\n    height: 140px;\n    width: 100%;\n    z-index: 9999;\n    position: absolute;\n    top: 0;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n}\n\n.navigation_buttons {\n    margin-right: 3%;\n}\n\n.content_body {\n    z-index: 999;\n    position: absolute;\n    bottom: 5%;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    align-items: center;\n    width: 94%;\n}\n\n.welcome_text {\n    position: absolute;\n    left: 5%;\n    top: 22%;\n    font-size: 47px;\n}\n\n.aboutus_text {\n    position: fixed;\n    left: 5%;\n    top: 17%;\n    font-size: 40px;\n}\n\n.first_h1 {\n    margin-bottom: 0;\n    margin-bottom: -3vh;\n}\n\n.second_h1  {\n    margin-top: 0;\n    margin-bottom: 0;\n}\n\nh6 {\n    margin-top: 0;\n    margin-bottom:0;\n}\n\n.cards {\n    background-color: #c9c9c94a;\n    width: 32%;\n    height: 34vh;\n    border-radius: 60px;\n    backdrop-filter: blur(5px);\n    display: flex;\n    flex-direction: column;\n    align-content: center;\n    justify-content: center;\n}\n\n.policycard {\n    background-color: #c9c9c94a;\n    width: 70%;\n    height: 70vh;\n    border-top-left-radius: 60px;\n    border-bottom-left-radius: 60px;\n    padding: 20px 30px;\n    margin: auto 0;\n}\n\n.logo {\n    width: 250px;\n    height: 125px;\n    position: absolute;\n    left: 4%;\n    top: 0;\n}\n\n.hamburgerLogo {\n    width: 150px;\n    height: 75px;\n    position: fixed;\n    right: 4%;\n    top: 16px;\n    z-index: 1;\n}\n\n.right_buttons_container {\n    position: absolute;\n    right: 4%;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n}\n\n.demo_button {\n    width: 150px;\n    height: 40px;\n    background-color: #fff;\n    border-radius: 30px;\n    border: none;\n    pointer-events: none;\n    margin-top: 80px;\n    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);\n}\n\n.order_button:hover {\n    background-color: blue;\n    color:#fff;\n}\n\n.logo_disable {\n    pointer-events: none;\n}\n\n.horizontal_team {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: 0px 10px 0px 10px;\n    /* padding: 18% 10px 10px 10px; */\n}\n\n.team_member {\n    font-weight: bold;\n    padding-left: 10px;\n}\n\n.team_function {\n    margin-left: 10px;\n}\n\n.subText  {\n    font-family: 'LuxoraGoretskThin', sans-serif !important;\n    position: absolute;\n}\n\n.contact_body {\n    z-index: 999;\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    width: 94%;\n    height: 100%;\n}\n\n.contact_container {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 90%;\n}\n\niframe.contact_iframe iframe {\n    font-family: 'LuxoraGoretskThin', sans-serif !important;\n}\n\n@font-face {\n    font-family: 'Poppins';\n    src: url('../../assets/fonts/Poppins-SemiBold.ttf') format('truetype');\n}\n\n.animation_container {\n    overflow: hidden;\n    position: absolute;\n    transition: all 0.5s ease-in-out;\n    font-family: Poppins;\n    top: 29.25%;\n    left: 18.7%;\n    font-size: 35px;\n}  \n\n.responsiveCard {\n    position: absolute;\n    z-index: 9999999;\n    width: 470px;\n    height: 320px;\n    animation-delay: 1.5s;\n    animation-duration: 1s;\n    bottom: 50%;\n    background-color: #c9c9c94a;\n    border-radius: 60px;\n    backdrop-filter: blur(5px);\n    display: flex;\n    flex-direction: column;\n    align-content: center;\n    justify-content: center;\n}\n\n@media only screen and (max-width: 277px) {\n    .first_h1 span {\n        font-size: 40px !important;\n    }\n\n    .subText {\n        height: 50px !important;\n        width: 260px !important;\n        font-size: 19px !important;\n    }\n    \n    .second_h1 span {\n        margin-top: 7px !important;\n        font-size: 30px !important;\n    }\n    .responsiveCard {\n        width: 232px !important;\n        height: 240px !important;\n    } \n\n    .demo_button {\n        margin-top: 90px !important;\n    } \n\n    .horizontal_team {\n        margin: 12% 15% 0 10% !important;\n        font-size: 13px;\n    }\n    .responsive_video {\n        scale: 4 !important;\n    }\n}\n  \n\n@media only screen and (min-width: 278px) and (max-width: 385px) {\n    .first_h1 span {\n        font-size: 25px !important;\n    }\n\n    .subText {\n        height: 100px;\n        width: 310px;\n        font-size: 20px;\n    }\n    \n    .second_h1 span {\n        margin-top: 7px !important;\n        font-size: 25px !important;\n    }\n    .responsiveCard {\n        width: 255px !important;\n        height: 260px;\n    } \n\n    .demo_button {\n        margin-top: 110px !important;\n    } \n\n    .horizontal_team {\n        margin: 12% 15% 0 10% !important;\n        font-size: 15px;\n    }\n}\n@media only screen and (min-width: 386px) and (max-width: 404px) {\n\n    .horizontal_team {\n        margin: 10% 10% 0 6%;\n        font-size: 15px;\n    }\n\n    .subText {\n        height: 100px;\n        width: 323px !important;\n        font-size: 18px;\n    }\n\n    .responsiveCard {\n        width: 340px;\n        height: 230px;\n    } \n\n    .first_h1 span {\n        font-size: 38px !important;\n    }\n    \n    .second_h1 span {\n        margin-top: 30px !important;\n        font-size: 30px !important;\n    }\n\n    .demo_button {\n        margin-top: 120px;\n    } \n}\n\n/* Mobil ekranlar için stil */\n@media only screen and (min-width: 405px) and (max-width: 600px) {\n\n    .horizontal_team {\n        margin: 10% 10% 0 8%;\n        font-size: 14px;\n    }\n\n    .subText {\n        height: 100px;\n        width: 376px !important;\n        font-size: 20px;\n    }\n\n    .responsiveCard {\n        width: 340px;\n        height: 230px;\n    } \n\n    .first_h1 span {\n        font-size: 38px !important;\n    }\n    \n    .second_h1 span {\n        margin-top: 30px !important;\n        font-size: 30px !important;\n    }\n\n    .demo_button {\n        margin-top: 120px;\n    } \n}\n\n@media only screen and (min-width: 601px) and (max-width: 767px) {\n\n    .horizontal_team {\n        margin: 5% 10% 10% 10%;\n    }\n\n    .responsiveCard {\n        width: 90%;\n        height: 250px;\n    } \n\n    .first_h1 span {\n        font-size: 70px !important;\n    }\n    \n    .second_h1 span {\n        margin-top: 30px !important;\n        font-size: 50px !important;\n    }\n\n    .demo_button {\n        margin-top: 100px;\n    } \n}\n  /* Tablet ekranlar için stil */\n@media only screen and (min-width: 768px) and (max-width: 1023px) {\n    .horizontal_team {\n        margin: 16% 10px 10px 10px;\n    }\n\n    .first_h1 span {\n        font-size: 80px !important;\n        margin-bottom: 10px !important;\n    }\n    \n    .second_h1 span {\n        font-size: 60px !important;\n    }\n}\n\n@media only screen and (min-width: 1024px) and (max-width: 1038px){\n    .second_h1 span {\n        font-size: 87px !important;\n    }\n    .horizontal_team {\n        margin: 16% 10% 10% 10%;\n    }\n}\n\n  /* Dizüstü bilgisayarlar için stil */\n/* @media only screen and (min-width: 1024px) and (max-width: 1439px) { */\n    /* Dizüstü için özel stiller burada */\n/* } */\n  /* Masaüstü ekranlar için stil */\n/* @media only screen and (min-width: 1440px) { */\n    /* Masaüstü için özel stiller burada */\n/* } */\n\n@media screen and (max-width:1608px) {\n    .animation_container {\n        left: 19.7%;\n    }\n}\n\n@media screen and (max-width:1578px) {\n    .animation_container {\n        left: 36.7%;\n    }\n}\n\n@media screen and (max-width:1554px) {\n    .animation_container {\n        left: 19.7%;\n    }\n}\n\n@media screen and (max-width:1491px) {\n    .animation_container {\n        font-size: 25px;\n        left: 20.7%;\n        top: 34.25%;\n    }   \n}\n\n@media screen and (max-width:1302px) {\n    .animation_container {\n        left: 22.7%;\n        top: 34.25%;\n    }   \n}\n\n@media screen and (max-width:1215px) {\n    .animation_container {\n        font-size: 20px;\n        left: 23.7%;\n        top: 38.25%;\n    }\n}\n\n@media screen and (max-width:1116px) {\n    .animation_container {\n        font-size: 12px;\n        left: 25.7%;\n        top: 43.25%;\n    }\n}\n\n@media screen and (max-width:1060px) {\n    .animation_container {\n        font-size: 12px;\n        left: 25.7%;\n        top: 43.25%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navigation_bar": `video_navigation_bar__GGeEk`,
	"navigation_buttons": `video_navigation_buttons__1Jz14`,
	"content_body": `video_content_body__w+pt+`,
	"welcome_text": `video_welcome_text__NjApk`,
	"aboutus_text": `video_aboutus_text__kYPo8`,
	"first_h1": `video_first_h1__Y-l2M`,
	"second_h1": `video_second_h1__sdkxe`,
	"cards": `video_cards__gM7dF`,
	"policycard": `video_policycard__mvNDd`,
	"logo": `video_logo__nW2B1`,
	"hamburgerLogo": `video_hamburgerLogo__JCNsY`,
	"right_buttons_container": `video_right_buttons_container__Xcfto`,
	"demo_button": `video_demo_button__HhJhr`,
	"order_button": `video_order_button__uJFuX`,
	"logo_disable": `video_logo_disable__fBTZc`,
	"horizontal_team": `video_horizontal_team__MMqRE`,
	"team_member": `video_team_member__V6TQy`,
	"team_function": `video_team_function__UBWs6`,
	"subText": `video_subText__l0qco`,
	"contact_body": `video_contact_body__3mE2e`,
	"contact_container": `video_contact_container__eCLu4`,
	"contact_iframe": `video_contact_iframe__LHcJN`,
	"animation_container": `video_animation_container__jz+YZ`,
	"responsiveCard": `video_responsiveCard__AvXHC`,
	"responsive_video": `video_responsive_video__T2-9Y`
};
export default ___CSS_LOADER_EXPORT___;
